module.exports = __webpack_public_path__ + "static/kanmengou-7af0d0a07f798edcf9aa35894689cfb4.jpg";